import { cx } from '@fable/theme'

interface Props {
  className?: string
  animClass?: string
}

export const GoalCompleteStar = ({
  animClass = 'anim__goal-complete-star',
  className = '',
}: Props) => {
  return (
    <svg
      className={cx(animClass, className)}
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7375 6.2899C9.50856 6.31394 7.66211 4.66698 7.61893 2.58718C7.60473 2.11804 7.60116 1.63231 7.58696 1.16317C7.58247 0.606089 7.16364 0.0956528 6.55238 0.0131794C5.79434 -0.0947954 5.1373 0.476543 5.15138 1.14603C5.15784 1.64545 5.17782 2.14196 5.18428 2.64138C5.22745 4.72118 3.45719 6.449 1.23693 6.51409C0.702867 6.5294 0.202433 6.83793 0.0485942 7.31478C-0.182686 8.09455 0.444613 8.78883 1.23074 8.76195C1.25778 8.7561 1.27131 8.75318 1.29835 8.74733C3.51861 8.68224 5.36508 10.3292 5.40825 12.409C5.42245 12.8782 5.42602 13.3639 5.44022 13.833C5.45824 14.3872 5.86353 14.9005 6.44775 14.9889C7.18938 15.0861 7.82227 14.5343 7.81882 13.8482C7.81236 13.3487 7.80589 12.8493 7.78591 12.3528C7.74274 10.273 9.51301 8.54522 11.7419 8.52119C11.769 8.51534 11.7825 8.51241 11.8124 8.52024C12.6015 8.50705 13.1997 7.79102 12.9375 7.01779C12.7687 6.55345 12.2416 6.26677 11.7182 6.26547L11.7375 6.2899Z"
        fill="#FAC826"
      />
    </svg>
  )
}
